<template>
  <div class="sensors">
    <sensor-modal ref="sensorModal" @onClickSave="refreshList" />

    <!-- Modal para cargar las medidas del sensor-->
    <modal ref="viewMeasuresModal" :title="modalTitle">
      <template #content>
        <sensor-measures
          ref="viewMeasuresData"
          @onClickExit="hideModal(false)"
        />
      </template>
    </modal>

    <b-row>
      <b-col>
        <component
          ref="myCom"
          v-bind:is="currentView"
          v-if="isFormVisible"
          @created="refresh"
          @updated="refresh"
          @exit="hideForm"
        />
      </b-col>
    </b-row>

    <modal ref="helpModal" :title="modalTitle">
      <template #content>
        <help-sensors></help-sensors>
      </template>
    </modal>

    <!-- Boton registrar sensor-->
    <div v-if="dispNewSensor">
      <b-card class="md-3">
        <b-row>
          <b-col>
            <b-button
              class="buttonClass"
              variant="success"
              size="sm"
              style="margin: 0px !important"
              @click="showFormModal()"
              v-if="isUserAdmin()"
            >
              <i class="fas fa-plus" style="margin-right: 5px"></i>
              <span
                class="text-uppercase"
                style="font-weight: 600; font-size: 13px"
                >Registrar nuevo sensor</span
              >
            </b-button>
          </b-col>
          <b-col>
            <div>
              <img
                title="Ayuda"
                class="botonAyuda"
                :src="getImgUrl('help.svg')"
                @click="showModalHelp()"
              />
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <!-- SPACER-->
    <spacer-card></spacer-card>

    <b-row>
      <b-col>
        <sensors-table ref="sensorTable" @rowedit="showEditForm"  @rowview="showModal"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/*
refs, and $refs, are not reactive.

If you want to pick up the updated value, you should wait until
the next render cycle updates the DOM.

*/
import Modal from "@/components/common/Modal";
import Sensorsedit from "@/components/sensors/SensorsEdit";
import Sensorstable from "@/components/sensors/SensorsTable";
import SensorsEditModal from "@/components/sensors/SensorEditModal";
import SensorMeasures from "@/components/sensors/SensorMeasures";
import Spacer from "@/components/card/Spacer";
import UserService from "@/services/UserService";
import HelpSensors from "@/components/help/HelpSensors";

export default {
  data() {
    return {
      currentView: "sensors-edit",
      isFormVisible: false,
      modalTitle: "",
      dispNewSensor: true,
    };
  },
  components: {
    "sensors-edit": Sensorsedit,
    "sensors-table": Sensorstable,
    "sensor-modal": SensorsEditModal,
    "spacer-card": Spacer,
    "sensor-measures": SensorMeasures,
    modal: Modal,
    "help-sensors": HelpSensors,
  },
  methods: {
    showForm() {
      this.isFormVisible = true;
      this.dispNewSensor = false;
    },

    hideForm() {
      this.isFormVisible = false;
      this.dispNewSensor = true;
    },

    refresh() {
      this.hideForm();
      this.$refs.sensorTable.refreshList();
    },

    showEditForm(idsensor) {
      this.currentView = "sensors-edit";
      this.showForm();
      //Trick to render next DOM element to update ref from dynamic
      //component loaded
      this.$nextTick(() => {
        // DOM updated
        this.$refs.myCom.getSensor(idsensor);
      });
    },

    refreshList() {
      this.$refs.sensorTable.refreshList();
    },

    showFormModal(idSensor) {
      this.$refs.sensorModal.showModal(idSensor);
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },

    getImgUrl(image) {
      return require("@/assets/images/" + image);
    },
    showModalHelp() {
      this.modalTitle = "Ayuda - Crear nuevo sensor";
      this.$refs.helpModal.show();
    },

    showModal(idsensor) {
      this.modalTitle = "Medidas del sensor seleccionado";
      this.$refs.viewMeasuresModal.show();

      if (idsensor) {
        this.$nextTick(() => {
          // DOM updated
          this.$refs.viewMeasuresData.retrieveDataFromSensor(idsensor);
        });
      }
    },

    hideModal() {
      this.$refs.viewMeasuresData.hide();
    },
  },
};
</script>

<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.buttonClass {
  margin: 16px;
  margin-left: 5px;
  font-size: 12px;
  font-weight: bold;
}

.botonAyuda {
  width: 30px;
  margin-right: 10px;
  padding: 2px;
  float: right;
  cursor: pointer;
}

.botonAyuda:hover {
  padding: 0px;
}
</style>
